import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Search, Plus, FlaskConical } from "lucide-react";

export default function RegimensPage() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  const nav = useNavigate();

  const load = () => api.get(`/regimens${q ? `?q=${encodeURIComponent(q)}` : ""}`).then((r) => setList(r.data));
  useEffect(() => { load(); }, [q]);

  return (
    <div className="p-8 max-w-[1400px]" data-testid="regimens-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-display text-3xl font-bold text-stone-900">Regimens</h1>
          <p className="text-stone-500 mt-1">Chemotherapy regimens — standard library and your own.</p>
        </div>
        <button onClick={() => nav("/regimens/new")} className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-brand-500 hover:bg-brand-700 text-white font-semibold" data-testid="new-regimen-button">
          <Plus className="w-4 h-4" />New regimen
        </button>
      </div>

      <div className="bg-white border border-stone-200 rounded-xl shadow-soft p-4 mb-4">
        <div className="relative max-w-md">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
          <input data-testid="regimen-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search regimens…"
            className="w-full pl-10 pr-3 py-2.5 rounded-lg border border-stone-300 focus:border-brand-500 focus:ring-2 focus:ring-brand-100 focus:outline-none" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((r) => (
          <div key={r.id} className="bg-white border border-stone-200 rounded-xl p-5 hover:border-brand-300 hover:shadow-soft transition-all flex flex-col" data-testid={`regimen-card-${r.id}`}>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-brand-50 text-brand-700 flex items-center justify-center shrink-0">
                <FlaskConical className="w-5 h-5" />
              </div>
              <div className="min-w-0 flex-1">
                <Link to={`/regimens/${r.id}`} className="font-semibold text-stone-900 hover:text-brand-700 line-clamp-2">
                  {r.name}
                </Link>
                <div className="text-xs text-stone-500 mt-0.5">{r.disease_type}</div>
              </div>
            </div>
            <div className="mt-3 text-xs text-stone-500 flex flex-wrap gap-2">
              <span className={`px-2 py-0.5 rounded-full ${r.visibility === "standard" ? "bg-brand-50 text-brand-700" : "bg-stone-100 text-stone-600"}`}>
                {r.visibility}
              </span>
              <span>{r.cycles?.length || 0} cycle{r.cycles?.length !== 1 ? "s" : ""}</span>
              <span>by {r.owner_name}</span>
            </div>
            <div className="flex-1" />
            <div className="mt-4 flex gap-2">
              <Link to={`/regimens/${r.id}`} className="flex-1 text-center px-3 py-1.5 rounded-lg border border-stone-300 text-stone-700 hover:bg-stone-50 text-sm font-medium" data-testid={`view-regimen-${r.id}`}>View</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
